import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import plugin from './until/plugin'
// Vue.config.productionTip = false
// Vue.prototype.$axios = axios
//axios.defaults.baseURL = "";
axios.defaults.baseURL = 'https://soft.expoelec.cn/api'        //关键代码
// axios.defaults.baseURL = '/zhou'
// Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(plugin)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
